import { detect } from 'detect-browser'

export default detect
